<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="cb-window">
        <div class="cb-chrome">
          <span class="cb-dot cb-dot--r"></span>
          <span class="cb-dot cb-dot--y"></span>
          <span class="cb-dot cb-dot--g"></span>
          <span class="cb-prompt">&gt;_</span>
        </div>
        <pre class="cb-code"><code><span class="cb-row" v-for="(row, i) in rows" :key="i">
            <span class="cb-num">{{ i + 1 }}</span>
            <span class="cb-line">
              <span
              v-for="(tok, j) in row"
              :key="j"
              class="cb-tok"
              :class="`cb-tok--${tok.t}`"
              :style="{ width: tok.w + 'px' }"
            ></span>
            </span>
          </span></code></pre>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

type Tok = { t: 'k' | 'v' | 'i' | 's' | 'p'; w: number }

export default Vue.extend({
  name: 'PreviewCodeBlock',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
  data() {
    const rows: Tok[][] = [
      [{ t: 'k', w: 32 }, { t: 'i', w: 50 }, { t: 'p', w: 6 }, { t: 's', w: 40 }],
      [{ t: 'k', w: 28 }, { t: 'i', w: 24 }, { t: 'p', w: 18 }, { t: 'v', w: 44 }],
      [{ t: 'i', w: 14 }, { t: 'i', w: 30 }, { t: 'p', w: 8 }, { t: 's', w: 56 }],
      [{ t: 'k', w: 32 }, { t: 'i', w: 22 }],
      [{ t: 'i', w: 14 }, { t: 'i', w: 36 }, { t: 'p', w: 12 }, { t: 'v', w: 22 }],
    ]
    return { rows }
  },
})
</script>

<style scoped lang="scss">
.cb-window {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  background: #1E1E2D;
  min-height: 150px;
}
.cb-chrome {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.cb-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}
.cb-dot--r { background: #FF5F57; }
.cb-dot--y { background: #FEBC2E; }
.cb-dot--g { background: #28C840; }
.cb-prompt {
  margin-left: 8px;
  font-family: 'SF Mono', Menlo, monospace;
  font-size: 10px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.55);
}
.cb-code {
  flex: 1;
  margin: 0;
  padding: 10px 12px;
  background: transparent;
  font-family: 'SF Mono', Menlo, monospace;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cb-row {
  display: grid;
  grid-template-columns: 16px 1fr;
  align-items: center;
  gap: 8px;
}
.cb-num {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.3);
  text-align: right;
}
.cb-line {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.cb-tok {
  display: inline-block;
  height: 6px;
  border-radius: 2px;
}
.cb-tok--k { background: var(--accent); }
.cb-tok--v { background: #FFD66B; }
.cb-tok--i { background: rgba(255, 255, 255, 0.55); }
.cb-tok--s { background: #7AC58D; }
.cb-tok--p { background: rgba(255, 255, 255, 0.25); }
</style>
